import { render, staticRenderFns } from "./ntmSidebar.vue?vue&type=template&id=6169793e"
import script from "./ntmSidebar.vue?vue&type=script&lang=js"
export * from "./ntmSidebar.vue?vue&type=script&lang=js"
import style0 from "./ntmSidebar.vue?vue&type=style&index=0&id=6169793e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports